import 'react-loading-skeleton/dist/skeleton.css';

import { useTheme } from '@emotion/react';
import Visible from '@portalterreno/react-ui/Visible';
import React from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';

import DesktopContactFormSkeleton from './DesktopContactFormSkeleton';
import MobileContactFormSkeleton from './MobileContactFormSkeleton';

const ContactFormSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <SkeletonTheme
      baseColor={theme.palette.colors.azureish}
      borderRadius={6}
    >
      <Visible desktop>
        <DesktopContactFormSkeleton />
      </Visible>
      <Visible mobile>
        <MobileContactFormSkeleton />
      </Visible>
    </SkeletonTheme>
  );
};

export default React.memo(ContactFormSkeleton);
